import React from 'react';

const CommunityBeneficiaries = () => {
  return (
    <div className="key-statics">
      <div className="first-title">
        <h5>3.26 million</h5>
        <p>community beneficiaries of Vedanta’s social activities (FY2019: 3.1 million)</p>
      </div>
      <h5>
        2.99 million m<sup>3</sup>
      </h5>
      <p>
        of water saved
        <br /> (target: 2.5 million m<sup>3</sup>)
      </p>
    </div>
  );
};

export default CommunityBeneficiaries;
